import jbd1 from '../../Media/Ruko/JBD.webp'
import jbd2 from '../../Media/Ruko/JBD.webp'


const jbdimages =[
jbd1,jbd2
]

export default jbdimages;